import './Modal.css';

const Modal = ({ children, onClose, onBackdropClick, id, zIndex = 1 }) => (
    <div className="modal-container" style={{ zIndex }} id={id}>
        <div className="modal-backdrop" style={{ zIndex }} onClick={onBackdropClick}></div>
        <div className="modal-panel" style={{ zIndex: zIndex + 1 }}>
            <div className="close" onClick={onClose}>✕</div>
            {children}
        </div>
    </div>
);

export default Modal;
